import type { SVGProps } from 'react';

const SvgSocialMediaMarketing = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" {...props}>
    <g fill={props.color} data-name="social-media-marketing">
      <path d="M24 18.52A5.73 5.73 0 0 0 16.29 10l-.54.49-.37-.35a5.73 5.73 0 0 0-9.64 4.39 5.67 5.67 0 0 0 1.82 4l7.58 7.08a.76.76 0 0 0 .51.2.78.78 0 0 0 .51-.2ZM8.58 17.46a4.23 4.23 0 0 1 5.77-6.18l.88.82a.75.75 0 0 0 1 0l1.05-1A4.23 4.23 0 0 1 23 17.41l-7.33 6.66Z" />
      <path d="M31.19 16A15.19 15.19 0 1 0 16 31.19 15.2 15.2 0 0 0 31.19 16ZM2.31 16A13.69 13.69 0 1 1 16 29.69 13.7 13.7 0 0 1 2.31 16Z" />
    </g>
  </svg>
);

export default SvgSocialMediaMarketing;
